/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CatalogListResponse,
  CatalogLoadResponse,
  CatalogResponse,
  ControlListResponse,
} from '../models/index';
import {
    CatalogListResponseFromJSON,
    CatalogListResponseToJSON,
    CatalogLoadResponseFromJSON,
    CatalogLoadResponseToJSON,
    CatalogResponseFromJSON,
    CatalogResponseToJSON,
    ControlListResponseFromJSON,
    ControlListResponseToJSON,
} from '../models/index';

export interface CopyCatalogTemplateToTenantRequest {
    templateName?: string;
    sessionId?: string;
}

export interface GetAllCatalogsRequest {
    page?: string;
    pageSize?: string;
}

export interface GetCatalogByIdRequest {
    id: string;
}

export interface GetCatalogControlsRequest {
    id: string;
    page?: string;
    pageSize?: string;
}

/**
 * CatalogApi - interface
 * 
 * @export
 * @interface CatalogApiInterface
 */
export interface CatalogApiInterface {
    /**
     * 
     * @param {string} [templateName] Catalog template name (e.g. NIST_CSF_2.0)
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApiInterface
     */
    copyCatalogTemplateToTenantRaw(requestParameters: CopyCatalogTemplateToTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CatalogLoadResponse>>;

    /**
     */
    copyCatalogTemplateToTenant(requestParameters: CopyCatalogTemplateToTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CatalogLoadResponse>;

    /**
     * 
     * @param {string} [page] 
     * @param {string} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApiInterface
     */
    getAllCatalogsRaw(requestParameters: GetAllCatalogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CatalogListResponse>>;

    /**
     */
    getAllCatalogs(requestParameters: GetAllCatalogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CatalogListResponse>;

    /**
     * 
     * @param {string} id Catalog ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApiInterface
     */
    getCatalogByIdRaw(requestParameters: GetCatalogByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CatalogResponse>>;

    /**
     */
    getCatalogById(requestParameters: GetCatalogByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CatalogResponse>;

    /**
     * 
     * @param {string} id CatalogID
     * @param {string} [page] 
     * @param {string} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApiInterface
     */
    getCatalogControlsRaw(requestParameters: GetCatalogControlsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ControlListResponse>>;

    /**
     */
    getCatalogControls(requestParameters: GetCatalogControlsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ControlListResponse>;

}

/**
 * 
 */
export class CatalogApi extends runtime.BaseAPI implements CatalogApiInterface {

    /**
     */
    async copyCatalogTemplateToTenantRaw(requestParameters: CopyCatalogTemplateToTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CatalogLoadResponse>> {
        const queryParameters: any = {};

        if (requestParameters['templateName'] != null) {
            queryParameters['templateName'] = requestParameters['templateName'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/catalog`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CatalogLoadResponseFromJSON(jsonValue));
    }

    /**
     */
    async copyCatalogTemplateToTenant(requestParameters: CopyCatalogTemplateToTenantRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CatalogLoadResponse> {
        const response = await this.copyCatalogTemplateToTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllCatalogsRaw(requestParameters: GetAllCatalogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CatalogListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/catalog`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CatalogListResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAllCatalogs(requestParameters: GetAllCatalogsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CatalogListResponse> {
        const response = await this.getAllCatalogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCatalogByIdRaw(requestParameters: GetCatalogByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CatalogResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getCatalogById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/catalog/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CatalogResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCatalogById(requestParameters: GetCatalogByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CatalogResponse> {
        const response = await this.getCatalogByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCatalogControlsRaw(requestParameters: GetCatalogControlsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ControlListResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getCatalogControls().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/catalog/{id}/controls`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlListResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCatalogControls(requestParameters: GetCatalogControlsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ControlListResponse> {
        const response = await this.getCatalogControlsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
